// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const InfoAltIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M15 1.875C18.5039 1.875 21.7969 3.24609 24.2812 5.71875C26.7539 8.20312 28.125 11.4961 28.125 15C28.125 18.5039 26.7539 21.7969 24.2812 24.2812C21.8086 26.7656 18.5039 28.125 15 28.125C11.4961 28.125 8.20312 26.7656 5.71875 24.2812C3.23437 21.7969 1.875 18.5039 1.875 15C1.875 11.4961 3.23437 8.20312 5.71875 5.71875C8.20312 3.24609 11.4961 1.875 15 1.875ZM15 0C6.71484 0 0 6.71484 0 15C0 23.2852 6.71484 30 15 30C23.2852 30 30 23.2852 30 15C30 6.71484 23.2852 0 15 0ZM15 5.625C13.4414 5.625 12.1875 6.87891 12.1875 8.4375C12.1875 9.99609 13.4414 11.25 15 11.25C16.5586 11.25 17.8125 9.99609 17.8125 8.4375C17.8125 6.87891 16.5586 5.625 15 5.625ZM15 13.125H13.125C12.0937 13.125 11.25 13.9687 11.25 15C11.25 16.0313 12.0937 16.875 13.125 16.875V22.5C13.125 23.5313 13.9687 24.375 15 24.375C16.0313 24.375 16.875 23.5313 16.875 22.5V15C16.875 13.9687 16.0313 13.125 15 13.125Z"/>
        </svg>
      )
    }
  </Icon>
);

export default InfoAltIcon;
